import { useCallback, useState } from 'react'
import ExpandMore from '@mui/icons-material/ExpandMore'

import { formatDate } from 'features/RiskManagement/Assessments/Components/formatDate'

import type { IWisDetailsModalAccordionProps } from './types'

const expandMoreStyle = {
  width: 16,
  height: 16
}

export const WisDetailsAccordion = ({
  scenario,
  children
}: React.PropsWithChildren<IWisDetailsModalAccordionProps>) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false)

  const toggleDropdown = useCallback(() => {
    setIsDropdownOpen((state) => !state)
  }, [])

  return (
    <div>
      <button
        type='button'
        className='w-full border-b py-2 cursor-pointer text-left'
        onClick={toggleDropdown}
        onKeyDown={(event) => {
          ;(event.key === 'Space' || event.key === 'Enter') && toggleDropdown()
        }}
      >
        <div className='flex items-baseline w-full'>
          <div className='font-medium flex-none w-24 pr-2 overflow-hidden text-ellipsis whitespace-nowrap'>
            {scenario.name}
          </div>
          <div className='flex-none w-32 pr-2'>{scenario.statusCode}</div>
          <div className='flex-none w-28 pr-2'>
            {formatDate(scenario.dateCreated, 'trimmed')}
          </div>
          <div className='flex-1 relative pr-6'>
            <div className='overflow-hidden text-ellipsis text-nowrap max-w-24 whitespace-nowrap pr-2'>
              {scenario.author}
            </div>
            <span
              className={`absolute px-4 right-0 bottom-0 top-0 transform ${isDropdownOpen ? 'rotate-180' : ''} transition ease-out duration-200`}
            >
              <span className='sr-only'>
                {isDropdownOpen ? 'Collapse details' : 'Expand details'}
              </span>
              <ExpandMore style={expandMoreStyle} className='text-gray-700' />
            </span>
          </div>
        </div>
      </button>
      <div
        className={`transition-opacity overflow-hidden ${isDropdownOpen ? 'h-auto opacity-100' : 'h-0 opacity-0'}`}
      >
        {children}
      </div>
    </div>
  )
}

export default WisDetailsAccordion
